import styled from 'styled-components';
import { color } from '@lendi-ui/color';
import { mb, mt, mx, py } from '@lendi-ui/spacing';
import { heading } from '@lendi-ui/typography';

export const Wrapper = styled.div`
  ${mx({ mobile: 'md', desktop: 'xxs' })}
  ${py('lg')}
  border-top: 1px solid ${color('shade.100')};
  border-bottom: 1px solid ${color('shade.100')};
  img {
    max-width: 100%;
  }
`;

export const Title = styled.h3`
  ${heading({ size: 'sm', color: 'secondary.500' })}
  ${mt('nil')}
  ${mb('sm')}
`;
